import styled from 'styled-components';

interface IProps {
    fadePercentage: number;
}

export const Overlay = styled.div<IProps>`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(
        255,
        255,
        255,
        ${(props) => props.fadePercentage / 100}
    );
`;
